import {
    GET_CODEPROMOS,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
  
    UPDATE_CODEPROMO,
    UPDATE_CODEPROMO_SUCCESS,
    UPDATE_CODEPROMO_FAIL,
    
    ADD_NEW_CODEPROMO,
    ADD_CODEPROMO_SUCCESS,
    ADD_CODEPROMO_FAIL,

  } from "./actionType";

  // common success
  export const codePromoApiResponseSuccess = (actionType, data) => ({
    type: API_RESPONSE_SUCCESS,
    payload: { actionType, data },
  });
  // common error
  export const codePromoApiResponseError = (actionType, error) => ({
    type: API_RESPONSE_ERROR,
    payload: { actionType, error },
  });
  
  export const getCodePromos = () => ({
    type: GET_CODEPROMOS,
  });

  export const updateCodePromo = codePromo => ({
    type: UPDATE_CODEPROMO,
    payload: codePromo,
  });
  
  export const updateCodePromoSuccess = codePromo => ({
    type: UPDATE_CODEPROMO_SUCCESS,
    payload: codePromo,
  });
  
  export const updateCodePromoFail = error => ({
    type: UPDATE_CODEPROMO_FAIL,
    payload: error,
  });
  
  export const addNewCodePromo = codePromo => ({
    type: ADD_NEW_CODEPROMO,
    payload: codePromo,
  });
  
  export const addCodePromoSuccess = codePromo => ({
    type: ADD_CODEPROMO_SUCCESS,
    payload: codePromo,
  });
  
  export const addCodePromoFail = error => ({
    type: ADD_CODEPROMO_FAIL,
    payload: error,
  });